import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Trans, useTranslation } from 'react-i18next'
import { format } from 'date-fns'
import { DASH } from '../../appConstants'
import { isDisasterValNaN } from '../../utils/disasterRiskManagement/disaster'
// import { useRegisterDrillEarthQuakeTsunamiMutation } from '../../hooks/mutation/useRegisterDrillEarthQuakeTsunamiMutation'

type Props = {
  show: boolean
  hideModal: () => void
  forcastName?: string
  onYesAction: (text?: string) => void
}

const mockEarthquakeRes = {
  earthquake: {
    origin_time: new Date().toISOString(),
    area_epicenter_name: '震源地',
    magnitude: 7.5,
  },
  seismic_intensity: {
    seismic_intensity: '5',
    area_information_city_name: '震度',
  },
}

const mockTsunamiRes = {
  tsunami_warning_name: '大津波警報',
  max_height: '5',
  first_height_arrival_time: new Date(
    Date.now() + 30 * 60 * 1000
  ).toISOString(),
}

export const TsunamiAndEarthQuakeDrillModal = ({
  show,
  hideModal,
  forcastName,
  onYesAction,
}: Props) => {
  const { t } = useTranslation()
  const [inputValue, setInputValue] = useState('')

  useEffect(() => {
    if (show) {
      setInputValue('')
    }
  }, [show])

  if (!show) return null

  const seismic = mockEarthquakeRes.seismic_intensity
  const eq = mockEarthquakeRes.earthquake
  const tsunami = mockTsunamiRes
  // const registerDrillEarthQuakeTsunami = useRegisterDrillEarthQuakeTsunamiMutation()
  const vals = [
    `${t('LABELS.TIME_OF_OCCURRENCE')} ${format(
      new Date(eq.origin_time),
      'HH:mm'
    )}`,
    `${t('LABELS.EPICENTER')} ${forcastName}`,
    `${t('LABELS.MAGNITUDE')} ${!isDisasterValNaN(eq.magnitude) ? eq.magnitude : DASH
    }`,
    `${forcastName}${t('LABELS.SEISMIC_INTENSITY')}${seismic.seismic_intensity
    }`,
    tsunami.tsunami_warning_name,
    `${t('LABELS.EXPECTED_ARRIVAL_TIME')} ${format(
      new Date(tsunami.first_height_arrival_time),
      'HH:mm'
    )}`,
    `${t('LABELS.TSUNAMI_HEIGHT')} ${tsunami.max_height}`,
  ]

  return createPortal(
    <div className="modal-area without-overlay-bg modal-tsunami-earthquake uk-box-shadow-xlarge">
      <div className="modal-dialog uk-text-center color-white bg-grey-80">
        <div className="bg-grey-95 modal-padding uk-margin-small-bottom uk-border-rounded">
          <div className="warning-area uk-flex uk-flex-middle column-gap-22">
            <div className="square-repetition" />
            <div className="warning-heading color-red line-height-1">
              WARNING
            </div>
            <div className="square-repetition" />
          </div>

          <div className="drill-title">
            <Trans>LABELS.EARTHQUAKE_AND_TSUNAMI_INFO_OBTAINED_DRILL</Trans>
          </div>

          <div className="modal-pill-container">
            {vals.map((item) => (
              <div key={item} className="modal-pill bg-grey-80">
                {item}
              </div>
            ))}
            {vals.length % 2 !== 0 && <div className="modal-pill" />}
          </div>
        </div>

        <div className="bg-grey-95 modal-padding uk-border-rounded">

          <h3 className=".modal-title-disaster-text uk-margin-small-top uk-margin-remove-bottom">
            {t('TITLES.DISASTER_FREE_TEXT_DISPLAY_MESSAGE')}
          </h3>

          <textarea
            className="uk-textarea color-white uk-text-center uk-margin-small-top uk-padding-small text-xl "
            rows={2}
            maxLength={100}
            draggable={false}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />

          <h2 className="drill-title">
            避難誘導サポートを開始しますか？
          </h2>

          <div className="modal-footer uk-margin-medium-bottom uk-flex uk-flex-middle uk-flex-around">
            <button
              type="button"
              className="uk-button uk-button-link color-white modal-pill bg-grey-80"
              onClick={() => {
                onYesAction(inputValue)
              }}
            >
              <Trans>BUTTONS.CONFIRM_YES</Trans>
            </button>

            <button
              className="uk-button uk-button-link color-white modal-pill bg-grey-80"
              type="button"
              onClick={hideModal}
            >
              <Trans>BUTTONS.CONFIRM_NO</Trans>
            </button>
          </div>

          <div className="warning-area">
            <div className="square-repetition" />
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}
